import { Action } from '@ngrx/store';
import { JobExport } from '../../../vas/business-objects/job-export/job-export.model';
import { JobExportParams } from '../../atoms/job-export-params/job-export-params.model';

export const CREATE = '[JobExport] Create';
export const CREATE_SUCCESS = '[JobExport] Create Success';
export const CREATE_FAIL = '[JobExport] Create Fail';
export const DOWNLOAD = '[JobExport] Download';
export const DOWNLOAD_FAIL = '[JobExport] Download Fail';
export const DOWNLOAD_SUCCESS = '[JobExport] Download Success';
export const SET_PARAMS = '[JobExport] Set Params';
export const POLL_SUCCESS = '[JobExport] Poll Success';
export const POLL_FAIL = '[JobExport] Poll Fail';
export const LOAD_ALL = '[JobExport] Load All';
export const LOAD_ALL_SUCCESS = '[JobExport] Load All Success';
export const LOAD_ALL_FAIL = '[JobExport] Load All Fail';
export const REMOVE = '[JobExport] Remove';
export const REMOVE_SUCCESS = '[JobExport] Remove Success';
export const REMOVE_FAIL = '[JobExport] Remove Fail';

export class CreateAction implements Action {
    readonly type = CREATE;
}

export class CreateSuccessAction implements Action {
    readonly type = CREATE_SUCCESS;

    constructor(public payload: JobExport) {

    }
}

export class CreateFailAction implements Action {
    readonly type = CREATE_FAIL;

    constructor(public payload: Error) {

    }
}

export class DownloadAction implements Action {
    readonly type = DOWNLOAD;

    constructor(public payload: JobExport) {

    }
}

export class DownloadSuccessAction implements Action {
    readonly type = DOWNLOAD_SUCCESS;
}

export class DownloadFailAction implements Action {
    readonly type = DOWNLOAD_FAIL;

    constructor(public payload: Error) {

    }
}

export class SetParamsAction implements Action {
    readonly type = SET_PARAMS;

    constructor(public payload: JobExportParams) {

    }
}

export class PollSuccessAction implements Action {
    readonly type = POLL_SUCCESS;

    constructor(public payload: JobExport) {

    }
}

export class PollFailAction implements Action {
    readonly type = POLL_FAIL;

    constructor(public payload: Error) {

    }
}

export class LoadAllAction implements Action {
    readonly type = LOAD_ALL;

    constructor(public payload: string) {

    }
}

export class LoadAllSuccessAction implements Action {
    readonly type = LOAD_ALL_SUCCESS;

    constructor(public payload: Array<JobExport>) {

    }
}

export class LoadAllFailAction implements Action {
    readonly type = LOAD_ALL_FAIL;

    constructor(public payload: Error) {

    }
}

export class RemoveAction implements Action {
    readonly type = REMOVE;

    constructor(public payload: JobExport) {

    }
}

export class RemoveSuccessAction implements Action {
    readonly type = REMOVE_SUCCESS;
}

export class RemoveFailAction implements Action {
    readonly type = REMOVE_FAIL;

    constructor(public payload: Error) {

    }
}

export type JobExportActions
    = CreateAction
    | CreateSuccessAction
    | CreateFailAction
    | DownloadAction
    | DownloadSuccessAction
    | DownloadFailAction
    | SetParamsAction
    | PollSuccessAction
    | PollFailAction
    | LoadAllAction
    | LoadAllSuccessAction
    | LoadAllFailAction
    | RemoveAction
    | RemoveSuccessAction
    | RemoveFailAction
    ;



// WEBPACK FOOTER //
// ./src/app/pages/job-export-page/job-export.actions.ts